export default __webpack_public_path__ + "static/media/20_1_3.953867d7.png";